import { useState } from 'react';
import { Product } from '../types';

interface DeleteConfirmModalProps {
  product: Product;
  onConfirm: (id: number) => void;
  onCancel: () => void;
}

export function DeleteConfirmModal({ product, onConfirm, onCancel }: DeleteConfirmModalProps) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm(product.id);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-red-900/30 border border-red-700 rounded-lg p-4">
        <div className="flex items-center gap-3">
          <div className="text-red-400 text-3xl">⚠️</div>
          <div>
            <h4 className="font-semibold text-white">Confirmer la suppression</h4>
            <p className="text-gray-300">
              Êtes-vous sûr de vouloir supprimer <strong className="text-white">« {product.custom_name} »</strong> ?
            </p>
          </div>
        </div>
      </div>

      <p className="text-sm text-gray-500">
        Cette action est irréversible. L'historique des prix sera également supprimé.
      </p>

      <div className="flex gap-3 pt-2">
        <button
          onClick={onCancel}
          disabled={isDeleting}
          className="btn btn-secondary flex-1"
        >
          Annuler
        </button>
        <button
          onClick={handleConfirm}
          disabled={isDeleting}
          className="btn btn-danger flex-1"
        >
          {isDeleting ? 'Suppression...' : '🗑️ Confirmer la suppression'}
        </button>
      </div>
    </div>
  );
}